export default __webpack_public_path__ + "e55da8bdad6593d93c0ff4a58c98ed2f.png";